module.exports = "/img/_/_/_/assets/images/creeper/book/common//28.jpg?22a2344a790c5a590094d9f411f4ce4e";